import {
    alldone, forcestopnow, fps,
    ico_he,
    in_free_spins, picture_convert, reels_lenghts,
    reels_pos,
    rotated,
    round_running, server_config, server_result, set_forcestopnow,
    set_rotated, set_round_running, states,
    behavior_config
} from "../framework/src/engine/madnes/madnes_variables";
import {cylinder_pos, icons, last_symbol, symbols, win_lines} from "./rof_config";
import {
    madnes_is_in_autostart,
    madnes_reels_start,
    madnes_reels_stop,
    madnes_win_anim_reset
} from "../framework/src/engine/madnes/madnes";
import {madnes_add_to_render, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {
    madnes_audio_fade_out,
    madnes_audio_loop,
    madnes_audio_play,
    madnes_set_audio_volume
} from "../framework/src/engine/madnes/madnes_audio";
import {print_reels} from "./adapters/madnesGameAdapter";
import {
    madnes_get_pos_y,
    madnes_get_texture,
    madnes_set_cstm_val, madnes_set_pos_y,
    madnes_set_texture,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {result_lock} from "./rof_core_printer";
import {STATES} from "../framework/src/states/states";
import {result_control} from "./rof_core_res_ctrl";
import {madnes_anim_add, madnes_anim_add_oncomplete, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";

var rotate_start_time = 0;
var rotate_start_pos = [];
var rotate_start_in_accel = 0;
var rotate_start_swing = 0;
var can_stop = 0;
var rotate_control_start_time = 0;
var rotate_control_swing_end = 0;

var in_free_spins_pos = 0;
var in_free_spins_total = 0;

var frame_blur = 1;
var frame_sharp = 0;

var autospin_force = false;
var autospin_force_enabled = false;

var remove_bet_disabled = false;

var audioForceStopPlayed = false;

//function rotate_onclick() {
//	madnes_audio_play("button_click");
//}

function get_current_time()
{
    return window.performance ? window.performance.now() : new Date().getTime();
}

export function rof_rotate_run(/*autostarted*/)
{
    if(round_running) //waiting for end round
    {
        return;
    }

    rotate_start();
}

var spin_start_time = null;

function rotate_start()
{
    autospin_force_enabled = false;

    if(rotated == 0)
    {
        //console.time('rotate');
        // madnes_on_round_start();

        spin_start_time = get_current_time();

        // madnes_show_stop();

        madnes_win_anim_reset();

        for(var i = 0; i < server_config.logic.reels.length; i++)
        {
            while(stopposin[i] > server_config.logic.reels[i].length)
            {
                stopposin[i] = stopposin[i] * 1 - server_config.logic.reels[i].length;
                stopposin_old[i] = stopposin[i];
                reels_pos[i] = stopposin[i] * ico_he;
            }
        }

        // if(autostart != "∞" && autostart*1 > 0 && !in_free_spins)
        // {
        // 	autostart = autostart*1-1;
        // }


        set_rotated(1); // rotated = 1;

        startposin = JSON.parse(JSON.stringify(stopposin));

        hide_all_lines();

        if(!in_free_spins)
        {
            // madnes_new_round();

        }
        else
        {
            set_round_running(true);
            // round_running = true;
        }

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            symbols[i] = 0;
            last_symbol[i] = -1;
            rotate_start_pos[i] = reels_pos[i];
        }

        can_stop = 0;

        rotate_start_time = get_current_time();

        rotate_control_start_time = 0;
        rotate_start_in_accel = 0;
        rotate_start_swing = 0;
        set_forcestopnow(0); // forcestopnow = 0;

        //madnes_audio_play("REEL_START");

        madnes_add_to_render(rotate_start);
        madnes_reels_start();

    } else {

        var time = get_current_time() - rotate_start_time;

        if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            //behavior_config.reel.acceleration.accelerationHeight &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // back
            var time_perc = ( ( 100 / ( behavior_config.reel.acceleration.moveBackTime * 1000 ) ) * time ) / 100;
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            //behavior_config.reel.acceleration.accelerationHeight &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // keep
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * 1 );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&
            behavior_config.reel.acceleration.accelerationHeight &&
            //time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveTime * 1000 &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // acc
            var time_perc =
                1 - (
                    (
                        (
                            100 / (
                                //behavior_config.reel.acceleration.moveTime * 1000
                                behavior_config.reel.acceleration.moveBackTime * 1000
                            )
                        ) * (
                            time - (
                                behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000
                            )
                        )
                    ) / 100
                );

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }

        }
        else if(
            rotate_start_in_accel == 0
        )
        {
            // rotate accel start or repeat

            madnes_audio_play("REEL_START_reels");

            madnes_set_audio_volume('REEL_BG', server_config["behavior"]["sound"]["volume"]["spin"]);
            madnes_audio_loop("REEL_BG");

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i];
            }

            rotate_start_time = get_current_time();

            if(++rotate_start_swing >= behavior_config.reel.acceleration.swingCount)
            {

                rotate_start_in_accel = 1;

                //rotate_control_start_sym = Math.round(rotate_start_pos[0] / ico_he);
                rotate_control_start_time = get_current_time();
            }
        }
        else if(
            rotate_start_in_accel == 1
        )
        {
            // accel start
            var start_speed = behavior_config.reel.acceleration.accelerationHeight / behavior_config.reel.acceleration.moveBackTime;
            if(!isFinite(start_speed) || isNaN(start_speed))
            {
                start_speed = 0;
            }

            var end_speed = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                end_speed = behavior_config.reel.spin.freeSpinSpeed;
            }

            var end_time = behavior_config.reel.spin.timeToReachFullSpeed * 1000;

            var perc = 0;
            var speed = 0;
            var pos = 0;
            var sampling = 10;

            for(var i = 0; i <= time; i = i * 1 + sampling * 1)
            {
                perc = 100 / end_time * i;
                if(!isFinite(perc) || isNaN(perc))
                {
                    perc = 0;
                }
                speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
            }

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] + pos * ico_he;
            }

            if(
                !(
                    time < behavior_config.reel.spin.timeToReachFullSpeed * 1000
                )
            )
            {
                pos = 0;

                for(var i = 0; i <= ( behavior_config.reel.spin.timeToReachFullSpeed * 1000 ); i = i * 1 + sampling * 1)
                {
                    perc = 100 / end_time * i;
                    if(!isFinite(perc) || isNaN(perc))
                    {
                        perc = 0;
                    }
                    speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                    pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
                }

                rotate_control_swing_end = pos;
                from_acce = true;

                madnes_rem_from_render(rotate_start);
                madnes_add_to_render(rotate_control);
            }
        }

        print_reels();
    }
}

// Kontrola probihajici rotace valcu
//var alldone = new Array();
var spin_bg_played = new Array();
var stopped = new Array();

export var stopposin = new Array();
export var startposin = new Array();

var stopposin_round = new Array();
var stopping = new Array();

export var stopposin_old = new Array();
var stoppostime_br = new Array();
var stoppostime = new Array();

var stoppos_swing = new Array();

var all_set_for_stop = 0;

var from_acce = false;

var reels_pos_tmp = new Array();
var reels_pos_tmp2 = new Array();

function rotate_control()
{
    var time = get_current_time();

    if(rotated == 1 || all_set_for_stop == 0)
    {
        if(from_acce) {
            for(var i = 0; i < reels_pos.length; i++)
            {
                if(behavior_config.reel.spin.motionBlur == 1)
                {
                    /*madnes_sprite_set_frame("reels_bufer_" + i + "_S0", frame_blur);
                    madnes_sprite_set_frame("reels_bufer_" + i + "_S1", frame_blur);
                    madnes_sprite_set_frame("reels_bufer_" + i + "_S2", frame_blur);*/

                    for(var j = 0; j <= 2; j++) {
                        var txt = get_texture_key(madnes_get_texture("reels_bufer_" + i + "_S" + j));
                        madnes_set_texture("reels_bufer_" + i + "_S" + j, txt + "_blur");
                    }
                }
            }
        }

        from_acce = false;

        // Toci se a zatim se neceka ukonceni

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(server_result != null && result_lock == 0)
            {
                stopposin[i] = -1;
                stopposin_round[i] = 0;
                stopping[i] = 0;
                stoppostime_br[i] = -1;
                stoppos_swing[i] = 0;
                stoppostime[i] = -1;
                can_stop = 1;
            }

            alldone[i] = 0;
            spin_bg_played[i] = 0;

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }

            reels_pos[i] =
                (
                    rotate_start_pos[i] +
                    (
                        (
                            (
                                (
                                    time - rotate_control_start_time - (
                                        behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                    )
                                ) / 1000
                            ) * cs
                        ) + rotate_control_swing_end
                    ) * ico_he
                );
            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );
        }
    }
    else
    {
        // Je na case ukoncit toceni na spravnych pozicich

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(stopposin[i] == -1)
            {
                // Nejsou nastaveny pozice pro ukonceni -> nastavuji
                if(forcestopnow == 1)
                {
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + ( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i];
                    }

                }
                else
                {
                    var del = 1;
                    if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
                    {
                        del = behavior_config.reel.spin.delayBetweenReelStops;
                    }
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + /*(i * del) + */( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( i * del );
                    }
                }


                while(stopposin[i] <= 0)
                {
                    stopposin[i] = ( reels_lenghts[i] * 1 ) - stopposin[i];
                }

                stopposin_old[i] = stopposin[i];
            }

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }
            var end_break_reel_dist = madnes_get_end_dist();

            //var ttrfs = behavior_config.reel.spin.timeToReachFullSpeed;
            var ttrns = behavior_config.reel.spin.timeToReachNullSpeed;

            if(forcestopnow == 1)
            {
                end_break_reel_dist = 0;
                ttrns = 0.01;
            }

            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );

            if(
                forcestopnow == 0 &&
                (
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= symbdiff &&
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= 0
                )
            )
            {
                reels_pos[i] =
                    (
                        rotate_start_pos[i] +
                        (
                            (
                                (
                                    (
                                        time - rotate_control_start_time - (
                                            behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                        )
                                    ) / 1000
                                ) * cs
                            ) + rotate_control_swing_end
                        ) * ico_he
                    );
            }
            else if(stoppostime[i] == -1)
            {
                stopping[i] = 1;

                if(stoppostime_br[i] == -1)
                {
                    stoppostime_br[i] = time;
                }

                var dif_time = time - stoppostime_br[i];

                var cur_end = 0;

                if(dif_time <= ttrns * 1000)
                {
                    dif_time = madnes_get_dist_break(dif_time);

                    reels_pos[i] =
                        (
                            ( ( ( stopposin[i] + 0 ) - ( end_break_reel_dist * 1 ) + ( dif_time * 1 ) ) ) * ico_he

                        );
                }
                else
                {
                    cur_end = 1;
                }

                if(cur_end == 1)
                {
                    stoppostime[i] = time;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 ) * ico_he
                        );

                    if(alldone[i] == 0)
                    {
                        sound_reel_stop();

                        if(i === cylinder_pos.length - 1) {

                            madnes_audio_fade_out("REEL_BG", 500);
                        }

                        /*for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            var texture = madnes_get_texture("reels_bufer_" + i + "_" + j).replace("_blur", "");

                            madnes_set_texture("reels_bufer_" + i + "_" + j, texture);
                            //madnes_sprite_set_frame("reels_bufer_" + i + "_" + j, frame_sharp);
                            //madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");
                        }*/

                        for(var spos = 0; spos <= 2; spos++)
                        {
                            var symbTxtName = picture_convert[server_result.result.reelMatrix[0][i][spos]];

                            madnes_set_texture("reels_bufer_" + i + "_S" + (2 - spos), symbTxtName);
                            //madnes_sprite_set_frame("reels_bufer_" + i + "_S" + spos, 0);
                        }
                    }
                }
            }
            else
            {
                var end_time = stoppostime[i];
                var dif_time = time - end_time;

                var bh = behavior_config.reel.brake.brakeHeight;
                var kt = behavior_config.reel.brake.keepTime;
                var mbt = behavior_config.reel.brake.moveBackTime;
                //var mt = behavior_config.reel.brake.moveTime;
                var mt = behavior_config.reel.brake.moveBackTime;


                cs = behavior_config.reel.spin.commonSpeed;
                if(in_free_spins)
                {
                    cs = behavior_config.reel.spin.freeSpinSpeed;
                }

                //cs - rychlost
                //bh - vyska
                mt = bh / cs;

                var swc = behavior_config.reel.brake.swingCount;

                var _mt = mt * 1000;
                var _kt = kt * 1000;
                var _mbt = mbt * 1000;

                if(dif_time < _mt)
                {
                    var add_pos = ( ( (100 / ( mt * 1000 ) ) * dif_time ) / 100 ) * bh;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );
                }
                else if(dif_time >= _mt && dif_time < _mt + _kt)
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + bh ) * ico_he
                        );
                }
                else if(dif_time >= (_mt + _kt) && dif_time < (_mt + _kt + _mbt))
                {
                    var time2 = dif_time - ( mt * 1000 + kt * 1000 );
                    var add_pos = bh - ( ( ( (100 / ( mbt * 1000 ) ) * time2 ) / 100 ) * bh );

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );

                    reels_pos_tmp[i] = reels_pos[i];
                }
                else if(forcestopnow == 0 && dif_time >= (_mt + _kt + _mbt) && dif_time < (_mt + _kt + _mbt) * 1.7)
                {
                    var start_time = _mt + _kt + _mbt;
                    var curr_time = dif_time - start_time;
                    end_time = (_mt + _kt + _mbt) * 1.7 - start_time;

                    var start_pos = reels_pos_tmp[i];
                    var end_in = ico_he * bh * 0.1;

                    var pos_shift = end_in * curr_time / end_time + start_pos;
                    //reels_pos[i] = start_pos - (pos_shift - start_pos);
                    reels_pos[i] = pos_shift;

                    reels_pos_tmp2[i] = reels_pos[i];

                    if(i === 3 && !in_free_spins  && !madnes_is_in_autostart())
                    {
                        states.setState(STATES.FORCESPIN);
                        // autospin_force_enabled = true;
                        // madnes_show_spin();
                    }
                }
                else if(forcestopnow == 0 && dif_time >= (_mt + _kt + _mbt) * 1.7 && dif_time <= (_mt + _kt + _mbt) * 2.1)
                {

                    var start_time = (_mt + _kt + _mbt) * 1.7;
                    var curr_time = dif_time - start_time;
                    end_time = (_mt + _kt + _mbt) * 2.1 - start_time;

                    var start_pos = ( stopposin[i] * ico_he);
                    var end_pos = reels_pos_tmp2[i];
                    var end_in = end_pos - start_pos;

                    var pos_shift = end_in * curr_time / end_time + start_pos;

                    reels_pos[i] = end_pos - (pos_shift - start_pos);
                    //reels_pos[i] = pos_shift;
                }
                else
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0  ) * ico_he
                        );

                    if(++stoppos_swing[i] < swc)
                    {
                        stoppostime[i] = time;
                    }
                    else
                    {
                        alldone[i] = 1;
                    }
                }

            }
        }

        if(alldone.indexOf(0) == -1)
        {
            audioForceStopPlayed = false;

            //console.timeEnd('rotate');
            setTimeout(() => {

                madnes_reels_stop();
                result_control();

            }, 200);
            madnes_rem_from_render(rotate_control);
        }
    }

    print_reels();
}

var madnes_get_end_dist_tmp = -1;
var madnes_get_end_dist_tmp_free = -1;
function madnes_get_end_dist()
{
    if(in_free_spins)
    {
        if(madnes_get_end_dist_tmp_free != -1)
        {
            return madnes_get_end_dist_tmp_free;
        }
    }
    else
    {
        if(madnes_get_end_dist_tmp != -1)
        {
            return madnes_get_end_dist_tmp;
        }
    }

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;
    var distance = madnes_get_dist_break(total_time);

    if(in_free_spins)
    {
        madnes_get_end_dist_tmp_free = distance;
    }
    else
    {
        madnes_get_end_dist_tmp = distance;
    }

    return distance;
}

function madnes_get_dist_break(time)
{
    var sampling = 10;

    //var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveTime;
    var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveBackTime;

    if(!isFinite(end_speed) || isNaN(end_speed))
    {
        end_speed = 0;
    }

    var start_speed = behavior_config.reel.spin.commonSpeed;
    if(in_free_spins)
    {
        start_speed = behavior_config.reel.spin.freeSpinSpeed;
    }

    end_speed = start_speed;

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;

    var distance = 0;

    for(var i = 0; i <= time; i += sampling)
    {
        var proc = 100 - ( ( 100 / total_time ) * i );
        var speed = ( ( start_speed - end_speed ) * ( proc / 100 ) ) + end_speed;
        distance = ( distance * 1 ) + ( speed * sampling ) ;
    }
    distance = distance / 1000;
    return distance;
}

// Pozadavek na dotoceni valce
var rotate_stop_loading = 0;
export function rotate_stop()
{
    if(rotated != 0 && rotate_stop_loading == 0)
    {
        for(var i = 0; i < cylinder_pos.length; i++)
        {
            stopposin_old[i] = -1;
        }
        all_set_for_stop = 0;
        rotate_stop_loading = 1;
        var poss = 0;

        for(var i in server_result.result.reelMatrix[0])
        {
            for(var j in server_result.result.reelMatrix[0][i])
            {

                /*madnes_set_texture("reels_bufer_" + i + "_S" + ( 2 - j ), picture_convert[server_result.result.reelMatrix[0][i][j]] + "_blur");

                if(behavior_config.reel.spin.motionBlur == 1) {
                    madnes_sprite_set_frame("reels_bufer_" + i + "_S" + ( 2 - j ), frame_blur);
                } else {
                    madnes_sprite_set_frame("reels_bufer_" + i + "_S" + ( 2 - j ), frame_sharp);
                }*/

                if(behavior_config.reel.spin.motionBlur == 1) {
                    madnes_set_texture("reels_bufer_" + i + "_S" + ( 2 - j ), picture_convert[server_result.result.reelMatrix[0][i][j]] + "_blur");
                } else {
                    madnes_set_texture("reels_bufer_" + i + "_S" + ( 2 - j ), picture_convert[server_result.result.reelMatrix[0][i][j]] + "");
                }

            }
        }
        setTimeout(function() {

            all_set_for_stop = 1;
            rotate_stop_loading = 0;

        }, (1000 / ( fps ) ) * poss);
        set_rotated(0); //rotated = 0;
    }
}

function sound_reel_stop()
{
    if(forcestopnow) {

        if(!audioForceStopPlayed) {
            madnes_audio_play("REEL_STOP");
            audioForceStopPlayed = true;
        }
        return;
    }

    madnes_audio_play("REEL_STOP");
}

function rotate_release()
{
    if(autospin_force_enabled)
    {
        autospin_force = true;
    }

    autospin_force_enabled = false;
}

function forcestop_press()
{
    autospin_force = false;
}

function rot_on_bet_open()
{
    show_all_lines();
}

function show_all_lines()
{
    for(var line in win_lines) {
        madnes_set_visible(win_lines[line]['line'], true);
    }
}

function hide_all_lines()
{
    for(var line in win_lines) {
        madnes_set_visible(win_lines[line]['line'], false);
    }
}

function betmenu_open() {
    show_all_lines();
}

function get_texture_key(textureName)
{
    return textureName.replace('_blur', '').replace('_wink', '');
}

function is_in_autostart()
{
    return !!autostart;
    //return autostart * 1 > 0 || autostart == "∞";
}

export function devil_wink_eye_animation() {
    var matrix = server_result.result.reelMatrix[0];

    if(typeof matrix != 'undefined') {
        for(var x in server_result.result.reelMatrix[0]) {
            for(var y in matrix[x]) {
                if(picture_convert[matrix[x][y]] == 'symbol_Devil') {
                    if(Math.random() >= 0.7) {

                        var spriteName = "reels_bufer_" + x + "_S" + (2 - y);

                        madnes_set_texture(spriteName, "symbol_Devil_wink");
                        madnes_anim_add(spriteName, "anim", icons["symbol_Devil_wink"]['anim']);
                        madnes_set_cstm_val(spriteName, spriteName);

                        madnes_anim_add_oncomplete(spriteName, function (sprite) {
                            madnes_set_texture(sprite['cstmVal'], "symbol_Devil");
                            //madnes_sprite_set_frame(sprite['cstmVal'], 0);

                            madnes_set_pos_y(sprite['cstmVal'], madnes_get_pos_y(sprite['cstmVal']) - 3);
                        });

                        madnes_audio_play("zwink");
                        madnes_anim_play(spriteName, "anim", 120);

                        madnes_set_pos_y(spriteName, madnes_get_pos_y(spriteName) + 3);

                        return false;
                    }
                }
            }
        }
    }
}

